<!-- Heading -->
<div #scrollable class="scroll-sidebar scroll-sidebar-auth opacity-block-double">
  <div class="container-fluid pb-6 my-7 my-lg-12">
    <div class="row-col-blocks row align-items-center justify-content-between">
      <div class="col-12 col-lg">
        <div class="text-center">
          <i-feather class="logo-big effect3d" name="whatsapp" width="133" height="133"></i-feather>
        </div>
        <h1 class="font-bold text-center">WhatsApp</h1>
        <!-- Text -->
        <h4 class="text-center">Чтобы использовать WhatsApp:</h4>
        <ol>
          <li>Откройте WhatsApp на своём телефоне.</li>
          <li>
            Нажмите <strong>Меню</strong> <i-feather name="menu" class="wa-menu no-stroke mx-2"></i-feather> или
            <strong>Настройки</strong>
            <i-feather name="wa-settings" class="wa-setting no-stroke mx-2"></i-feather> и выберите
            <strong>WhatsApp Web.</strong>
          </li>
          <li>Нажмите загрузить QR-код ниже.</li>
          <li>Наведите свой телефон на этот экран, чтобы считать код.</li>
        </ol>
      </div>
      <div class="col-12 col-lg">
        <!--<p class="text-center mb-6">Отсканируйте QR-код через официальное приложение WhatsApp.</p>-->
        <!-- Form -->
        <alert [type]="'danger'" class="d-block"> In Progress </alert>
        <div [class.hidden]="!qr" class="qrcodeWrap" #qrcode></div>
        <ng-template [ngIf]="!qr">
          <div class="qrLoaderWrap">
            <div
              *ngIf="!loadingQR"
              (click)="getQR()"
              class="qrGoWrap d-flex align-items-center justify-content-center pointer"
            >
              <div
                (mousemove)="allService.effectMouseMove($event)"
                class="qrGo effectMouse effect-white d-flex align-items-center justify-content-center align-content-center flex-wrap"
              >
                <i-feather name="refresh-cw" class="icon-md mb-3"></i-feather>
                <div>Нажмите, чтобы загрузить QR-код</div>
              </div>
            </div>
            <div *ngIf="loadingQR" class="qrLoader">
              <div class="loader text-white">Загрузка...</div>
            </div>
            <img loading="lazy" class="mx-auto" width="250" height="250" src="/assets/images/qr.png" alt="QR" />
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
